import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { EncryptionResponse } from '../model/http/encrypt.model';
import { ConsumeService } from './consume.service';
import { of } from 'rxjs';
import { HashResponseMock } from 'src/mocks/bbvaMocks';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor(private consumeService: ConsumeService) { }

  getHashMessage(message: string): Observable<EncryptionResponse> {
    return this.consumeService.httpGet(`${Endpoints.encryp.hashMessage}/${message}/sha256`);
  }
}
